/**
 * # ⛓️ CURSOR_ANCHOR:ui:search-events-orchestrator
 * Оркестратор обработчиков событий поиска
 * Загружает модули и сохраняет публичный API для обратной совместимости
 */

(function() {
  'use strict';

  // Модули загружаются последовательно через отдельные script теги
  // Порядок загрузки:
  // 1. border-radius.js - управление border-radius формы поиска
  // 2. text-selection.js - обработка выделения текста
  // 3. sticky.js - логика sticky панели
  // 4. handlers.js - основные обработчики событий
  // 5. search-events.js (этот файл) - оркестратор

  // Публичный API сохраняется для обратной совместимости
  // Все функции доступны через глобальные объекты:
  // - window.updateSearchFormBorderRadius - из border-radius.js
  // - Остальные функции доступны через window.SEARCH_LANGUAGE, window.SEARCH_API и т.д.

  // Этот файл служит точкой входа и документацией структуры модулей
  // Реальная логика находится в отдельных модулях
  
  console.log('[SEARCH-EVENTS] Events module loaded');
})();














